
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class PDQuotationBOMGrid extends Serenity.EntityGrid<PDQuotationBOMRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.QuotationBOM'; }
        protected getDialogType() { return PDQuotationBOMDialog; }
        protected getIdProperty() { return PDQuotationBOMRow.idProperty; }
        protected getInsertPermission() { return PDQuotationBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return PDQuotationBOMRow.localTextPrefix; }
        protected getService() { return PDQuotationBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}